import { useAuth } from '../context/AuthContext';
import styles from './PageHeader.module.css';

export default function PageHeader({ title, description }) {
  const { user } = useAuth();

  const roleBadgeClass = {
    admin:    styles.badgeAdmin,
    supplier: styles.badgeSupplier,
    branch:   styles.badgeBranch,
  }[user?.role] || '';

  return (
    <div className={styles.header}>
      <div>
        <h1 className={styles.title}>{title}</h1>
        {description && <p className={styles.desc}>{description}</p>}
      </div>
      <span className={`${styles.badge} ${roleBadgeClass}`}>
        {user?.role} · {user?.name}
      </span>
    </div>
  );
}
